import request from "../infra/request";

const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

export const getAllReferrers = async () => {
  try {
    const { data } = await request.get(isDataFromPMS ? "/pms/admin/referrers" : "/admin/coreplus/referrers");
    return data && data instanceof Array ? { data } : { data: [] };
  } catch (error) {
    return { error };
  }
};

export const getAllClinics = async () => {
  try {
    const { data } = await request.get(isDataFromPMS ? "/pms/admin/clinics" : "/admin/coreplus/clinics");

    return data && data instanceof Array ? { data } : { data: [] };
  } catch (error) {
    return { error };
  }
};
